import McAfee from './McAfee.png';
import norton from './norton.png';

export default {
  norton,
  mcAfee: McAfee,
};
